import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import Nav from './nav/Nav';
import Sidebar from './nav/Sidebar';

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="layout-wrapper">
      <Nav onMenuToggle={toggleSidebar} />
      <div className="layout-content">
        <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
        <main className="main-content">
          <Container fluid>
            {children}
          </Container>
        </main>
      </div>
      
      {/* Mobile Overlay */}
      {sidebarOpen && (
        <div className="sidebar-overlay active" onClick={closeSidebar} />
      )}
    </div>
  );
};

export default Layout;
